import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
// import { MissionService } from './app.constant';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
import { DispatcherHomeService } from './dispatcher/dispatcherhome/dispatcherhome.service';
import { DispatcherComponent } from './dispatcher/dispatcher.component';
import { DispatcherService } from './dispatcher/dispatcher.service';
import { DispatcherHomeComponent } from './dispatcher/dispatcherhome/dispatcherhome.component';
import { TasksComponent } from './dispatcher/tasks/tasks.component';
import { TasksService } from './dispatcher/tasks/tasks.service';
import { AccountComponent } from './dispatcher/account/account.component';
import { AccountService } from './dispatcher/account/account.service';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// translate import
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { ImageUploadModule } from 'angular2-image-upload';
import { Configuration } from './app.configuration';
import { ConfigService } from './config.service';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { GodsviewComponent } from './dispatcher/godsview/godsview.component';
import { GodsviewService } from './dispatcher/godsview/godsview.service';
import { DebounceDirective } from './utils/debounce.directive';
import { CookieService } from 'ngx-cookie-service';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
// import { ScrollingModule } from '@angular/cdk/scrolling';

//   MatAutocompleteModule,
//   MatButtonModule,
//   MatButtonToggleModule,
//   MatCheckboxModule,
//   MatChipsModule,
//   MatDatepickerModule,
//   MatDialogModule,
//   MatExpansionModule,
//   MatGridListModule,
//   MatIconModule,
//   MatInputModule,
//   MatListModule,
//   MatMenuModule,
//   MatNativeDateModule,
//   MatPaginatorModule,
//   MatProgressBarModule,
//   MatProgressSpinnerModule,
//   MatRadioModule,
//   MatSelectModule,
//   MatSidenavModule,
//   MatSliderModule,
//   MatSlideToggleModule,
//   MatSnackBarModule,
//   MatSortModule,
//   MatTableModule,

// import { CdkTableModule } from '@angular/cdk/table';
import { OnlineStatusComponent } from './utils/online-status/online-status.component';
import { CommunicationService } from './dispatcher/communication.service';
import { LanguageInterceptor } from './utils/Interceptors/language.interceptor';

@NgModule({
  exports: [
    // CdkTableModule,
    // MatAutocompleteModule,
    // MatButtonModule,
    // MatButtonToggleModule,
    MatCardModule,
    // MatCheckboxModule,
    // MatChipsModule,
    // MatStepperModule,
    // MatDatepickerModule,
    // MatDialogModule,
    // MatExpansionModule,
    // MatGridListModule,
    // MatIconModule,
    // MatInputModule,
    // MatListModule,
    // MatMenuModule,
    // MatNativeDateModule,
    // MatPaginatorModule,
    // MatProgressBarModule,
    // MatProgressSpinnerModule,
    // MatRadioModule,
    MatRippleModule,
    // MatSelectModule,
    // MatSidenavModule,
    // MatSliderModule,
    // MatSlideToggleModule,
    // MatSnackBarModule,
    // MatSortModule,
    // MatTableModule,
    MatTabsModule
    // MatToolbarModule,
    // MatTooltipModule,
  ]
})
export class DemoMaterialModule { }

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    routing,
    BrowserAnimationsModule,
    DemoMaterialModule,
    // ScrollingModule,
    ImageUploadModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    AppComponent,
    AccountComponent,
    LoginComponent,
    DispatcherComponent,
    DispatcherHomeComponent,
    TasksComponent,
    // SearchPipe,
    GodsviewComponent,
    OnlineStatusComponent,
    DebounceDirective
  ],
  providers: [
    // MissionService,
    LoginService,
    DispatcherService,
    DispatcherHomeService,
    AccountService,
    // AuthService,
    // AuthGuard,
    Configuration,
    TasksService,
    ConfigService,
    GodsviewService,
    CookieService,
    CommunicationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
